import { clsx } from 'clsx';
import JxtEventDate from '../JxtEventDate';
import JxtEventSummary from '../JxtEventSummary';
import { IJxtFloorExceptionalClosingHoursDetails } from './types';
import JxtFloorInfos from '../JxtFloorInfos';

const JxtFloorExceptionalClosingHoursDetails = ({
  summary,
  date,
  floor,
  plan,
  className = '',
  showPlan = true,
}: IJxtFloorExceptionalClosingHoursDetails) => {
  return (
    <div className="flex flex-col">
      <div className={clsx('flex flex-col gap-4 px-1', className)}>
        <JxtEventSummary {...summary} />
        <JxtEventDate {...date} />
        <JxtFloorInfos {...floor} />
        {showPlan && plan && <div className="rounded-lg border border-neutral-20">{plan}</div>}
      </div>
    </div>
  );
};

export default JxtFloorExceptionalClosingHoursDetails;
